var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "proxy-products" }, [
    _vm._v("\n    Proxy products\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }